// import flatpickr from 'flatpickr' // flatpickr
// import 'flatpickr/dist/l10n/ja' // flatpickr日本語化

if (document.getElementById('system-favorite')) {
  favorite()
}

function favorite() {
  //  #####   ######  ##     ##
  //  ##  ##    ##    ####   ##
  //  #####     ##    ##  ## ##  ########
  //  ##  ##    ##    ##    ###
  //  #####     ##    ##     ##

  //    ###    ####    ####
  //   ## ##   ##  ##  ##  ##
  //  ##   ##  ##  ##  ##  ##
  //  #######  ##  ##  ##  ##
  //  ##   ##  ####    ####

  // お気に入りに追加
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-favorite')) {
      return
    }
    if (!e.target.classList.contains('active')) {
      e.target.classList.add('active')

      window.popToast('お気に入りリストに追加しました。')
    } else {
      e.target.classList.remove('active')
      window.popToast('お気に入りリストから解除しました。')
    }

    window.favCheck() // お気に入りチェック

    // お気に入り済み表示更新
    favoriteView()
  })

  //  ##   ##  ##  #####  ##      ##
  //  ##   ##  ##  ##     ##      ##
  //  ##   ##  ##  #####  ##  ##  ##
  //   ## ##   ##  ##     ##  ##  ##
  //    ###    ##  #####   ###  ###
  // お気に入りに入っているかを判定して表示を切り替える
  function favoriteView() {
    // 判定対象に.activeがついているかどうかを判定
    const btnList = document.getElementsByClassName('js-favorite')
    let isFav = false
    for (const item of btnList) {
      if (item.classList.contains('active')) {
        isFav = true
        break
      }
    }

    // 切り替え対象を切り替え
    const targetList = document.getElementsByClassName('js-favoriteView')
    if (isFav) {
      for (const item of targetList) {
        item.classList.add('active')
      }
    } else {
      for (const item of targetList) {
        item.classList.remove('active')
      }
    }
  }

  //  ##      ##   ####  ######
  //  ##      ##  ##       ##
  //  ##      ##   ###     ##    ########
  //  ##      ##     ##    ##
  //  ######  ##  ####     ##

  //  ##   ##    ###    ##      ##  ####      ###    ######  #####
  //  ##   ##   ## ##   ##      ##  ##  ##   ## ##     ##    ##
  //  ##   ##  ##   ##  ##      ##  ##  ##  ##   ##    ##    #####
  //   ## ##   #######  ##      ##  ##  ##  #######    ##    ##
  //    ###    ##   ##  ######  ##  ####    ##   ##    ##    #####

  window.addEventListener('input', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-textValidate')) {
      return
    }

    const val = e.target.value // 入力

    const target = e.target.dataset.validateTarget // 反映先
    const range = e.target.dataset.validateRange // 必要な文字長

    const pass = val.length >= range // 判定

    if (pass) {
      document.querySelector('.js-textValidate-send--' + target).classList.add('active')
      document.querySelector('.js-textValidate-error--' + target).classList.remove('active')
    } else {
      document.querySelector('.js-textValidate-send--' + target).classList.remove('active')
      document.querySelector('.js-textValidate-error--' + target).classList.add('active')
    }
  })
  //  ##      ##   ####  ######             ####  #####  ######
  //  ##      ##  ##       ##              ##     ##       ##
  //  ##      ##   ###     ##    ########   ###   #####    ##
  //  ##      ##     ##    ##                 ##  ##       ##
  //  ######  ##  ####     ##              ####   #####    ##

  // リスト追加後の設定

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-listAddSet')) {
      return
    }

    // お気に入り済み表示更新
    const targetList = document.getElementsByClassName('js-favoriteView')
    for (const item of targetList) {
      item.classList.add('active')
    }

    window.popToast('リストを作成しました。')

    setTimeout(() => {
      const targetList = document.getElementsByClassName('js-listAddSet-target')
      for (const iterator of targetList) {
        const type = iterator.dataset.clean
        if (type === 'active') {
          // クラスを消す
          iterator.classList.remove('active')
        }
        if (type === 'value') {
          // 入力欄を消す
          iterator.value = ''
        }
      }

      // 更新要素にリロードをかける
      const loadAjax = document.getElementById('js-loadAjax')
      if (loadAjax) {
        const item = loadAjax
        const url = item.dataset.url // 取得先
        const from = item.dataset.from // 取得要素
        const to = item.dataset.to // 差し替え要素
        window.applyAjax(url, 'GET', null, from, to, false, 'rep', false)
      }
    }, 500)
  })

  //  ##      ##   #####   #####    ####              ####    #####  ##
  //  ##      ##  ##   ##  ##  ##   ##  ##            ##  ##  ##     ##
  //  ##  ##  ##  ##   ##  #####    ##  ##  ########  ##  ##  #####  ##
  //  ##  ##  ##  ##   ##  ##  ##   ##  ##            ##  ##  ##     ##
  //   ###  ###    #####   ##   ##  ####              ####    #####  ######

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-wordDel')) {
      return
    }

    const targetBtn = document.querySelector('.js-wordDel--' + e.target.dataset.del).innerHTML
    window.dialogOpen('検索ワードを削除しますか？', '削除された検索ワードは後から復元することができません。', targetBtn)
  })

  //  ##      ##   ####  ######            ####    #####  ##
  //  ##      ##  ##       ##              ##  ##  ##     ##
  //  ##      ##   ###     ##    ########  ##  ##  #####  ##
  //  ##      ##     ##    ##              ##  ##  ##     ##
  //  ######  ##  ####     ##              ####    #####  ######

  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-listDel')) {
      return
    }

    e.target.closest('.js-listDel').classList.add('curr')

    const targetBtn = document.querySelector('.js-listDel--' + e.target.dataset.del).innerHTML
    const targetName = e.target.dataset.list
    window.dialogOpen(
      'リスト【' + targetName + '】を削除しますか？',
      '削除されたリストは後から復元することができません。',
      targetBtn
    )
  })

  //   ####  #####  ##     ##  ####
  //  ##     ##     ####   ##  ##  ##
  //   ###   #####  ##  ## ##  ##  ##
  //     ##  ##     ##    ###  ##  ##
  //  ####   #####  ##     ##  ####
  // キー操作監視
  window.addEventListener('keypress', function (e) {
    keyCheck(e)
  })
  window.addEventListener('input', function (e) {
    keyCheck(e)
  })
  function keyCheck(e) {
    const item = e.target.closest('.js-listAddSet-target')
    if (!item) {
      return
    }
    // Enterによる遷移を防止
    if (e.code && e.code === 'Enter') {
      e.preventDefault() // デフォルトのイベントを除去

      // document.querySelector('.js-listAddSet').click() // Ajax送信ボタンをクリク

      return false
    }
  }
}
//  #####    ###    ##   ##             ####  ##   ##  #####   ####  ##  ##
//  ##      ## ##   ##   ##            ##     ##   ##  ##     ##     ## ##
//  #####  ##   ##  ##   ##  ########  ##     #######  #####  ##     ####
//  ##     #######   ## ##             ##     ##   ##  ##     ##     ## ##
//  ##     ##   ##    ###               ####  ##   ##  #####   ####  ##  ##
// 詳細ページのお気に入りボタンのアクティブ切り替え
window.favCheck = function () {
  setTimeout(() => {
    const favBtn = document.getElementById('favorite')
    const favListBox = document.getElementById('favListBox')
    if (!favBtn || !favListBox) {
      return
    }

    if (document.querySelector('.js-modal--favorite')) {
      if (document.querySelector('.js-modal--favorite .js-favorite.active')) {
        favBtn.classList.add('active')
      } else {
        favBtn.classList.remove('active')
      }
    } else {
      if (!favBtn.classList.contains('active')) {
        favBtn.classList.add('active')
      } else {
        favBtn.classList.remove('active')
      }
    }
  }, 100)
}
